export default __webpack_public_path__ + "static/media/Group 1302@2x.0aa7af53.png";